import { render, staticRenderFns } from "./listadoZonasComunes.vue?vue&type=template&id=e97152ea&scoped=true"
import script from "./listadoZonasComunes.vue?vue&type=script&lang=js"
export * from "./listadoZonasComunes.vue?vue&type=script&lang=js"
import style0 from "./listadoZonasComunes.vue?vue&type=style&index=0&id=e97152ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97152ea",
  null
  
)

export default component.exports